/**
 * Fill in the Blanks Content Type
 * A content type wrapping the FITB element with title/description
 */

// Package version
import pkgJson from '../package.json';
export const VERSION = pkgJson.version;
export const PKG_NAME = pkgJson.name;

// Schema and types
export {
    fitbContentSchema,
    defaultFITBContentConfig,
    defaultFITBContentData,
    defaultFITBContentI18n,
    normalizeFITBContentData,
    serializableFITBContentData,
    type FITBContent,
    type FITBContentData,
    type FITBContentExercise,
    type FITBContentConfig,
    type FITBContentLayoutConfig,
    type FITBPlayerView,
} from './schema';
export {
    gradeFITBContentComposite,
    normalizeFitbContentAnswer,
    validateFITBContentComposite,
    type FITBContentCompositeAnswer,
} from './compositeGrading';

// Components
export { FITBContentEdit, type FITBContentEditProps } from './FITBContentEdit';
export { FITBContentPlayer, type FITBContentPlayerProps } from './FITBContentPlayer';

// Default export
export { fitbContentSchema as default } from './schema';

export { countFITBQuestions, fitbQuestionCounter } from './questionCount';
